import React from 'react'
import Halogen from 'halogen'
import ReactDom from 'react-dom';

export default class LoadingIndicator extends React.Component {
  static propTypes = {
    //loader: React.PropTypes.string.isRequired,
  };

  constructor(){
    super()
  }

  render () {
    const { loader, size } = this.props

    const color = '#206281';

    const style = {
        display: '-webkit-flex',
        display: 'flex',
        WebkitFlex: '0 1 auto',
        flex: '0 1 auto',
        WebkitFlexDirection: 'column',
        flexDirection: 'column',
        WebkitFlexGrow: 1,
        flexGrow: 1,
        WebkitFlexShrink: 0,
        flexShrink: 0,
        WebkitFlexBasis: '100%',
        flexBasis: '100%',
        maxWidth: '100%',
        height: size || '200px',
        WebkitAlignItems: 'center',
        alignItems: 'center',
        WebkitJustifyContent: 'center',
        justifyContent: 'center'
        };

    const containerStyles = {
         boxSizing: 'border-box',
         display: '-webkit-flex',
         display: 'flex',
         WebkitFlex: '0 1 auto',
         flex: '0 1 auto',
         WebkitFlexDirection: 'row',
         flexDirection: 'row',
         WebkitFlexWrap: 'wrap',
         flexWrap: 'wrap'
       };

    const Hloader = Halogen[loader || 'ClipLoader'];

    return (
      <div style={containerStyles}>
        <div style={style}>
          <Hloader color={this.props.color} size={size} color={color}/>
        </div>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js